
(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('CartaLiberacionDownloadService', CartaLiberacionDownloadService);

    CartaLiberacionDownloadService.$inject = ['$q','$http'];
    
        function CartaLiberacionDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idAsignacion, matricula) {
            
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-asignacions/liberacion/'+ idAsignacion + '/imprimir',
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "CartaLiberacion_" + matricula;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function(data, status, headers, config) {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();